import { portalApi } from "../../api/portalApi";

export const portalApiMap = () => portalApi;